import { render, staticRenderFns } from "./AreaEmbargadaGoPonto.vue?vue&type=template&id=392226fb&lang=pug"
import script from "./AreaEmbargadaGoPonto.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaGoPonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports